import {
  zonedTimeToUtc,
  utcToZonedTime,
  toDate,
  format as formatTZ,
} from 'date-fns-tz';
import {
  formatISO9075,
  format,
  formatDuration,
  isBefore,
  add,
  getHours,
  // parseISO,
  isSameDay,
  // addMinutes,
  set,
  differenceInSeconds,
  differenceInMinutes,
  getDay,
  max,
  min,
  setHours,
  endOfMonth,
  startOfMonth,
  // formatISO,
} from 'date-fns';
import { range, intersection, includes, capitalize, isArray } from 'lodash';
import { displayableFullName } from './contact';
import invert from 'invert-color';
const shortid = require('shortid');

export const SNACK_TIMEOUT = 1000;

export const INVITE_MODE = {
  contacts: 'contacts',
  group: 'group',
};

export const ADDRESS_TYPES = {
  home: 'home',
  work: 'work',
  billing: 'billing',
  other: 'other',
};

export const LOCATION_TYPES = {
  own: 'my_locations',
  lookup: 'lookup',
  find: 'find',
  url: 'url',
  none: 'none',
};

export const EVENT_TYPES = {
  meeting: 'Meeting',
  chat: 'Chat',
  audio: 'Audio',
  video: 'Video',
  webinar: 'Webinar',
  personal: 'Personal',
};

export const eventTypeText = (type) => {
  switch (type) {
    case EVENT_TYPES.meeting:
      return 'Meeting';
    case EVENT_TYPES.chat:
      return 'Chat';
    case EVENT_TYPES.audio:
      return 'Phone Call';
    case EVENT_TYPES.video:
      return 'Video Conference';
    case EVENT_TYPES.webinar:
      return 'Webinar';
    case EVENT_TYPES.personal:
      return 'Personal event';
    default:
      return 'Unnsupported event type';
  }
};

export const CALENDAR_VIEWS = {
  month: 'month',
  week: 'week',
  day: 'day',
  agenda: 'agenda',
};

/* For Recurrence, need to be sure that there are options for
Daily, Weekly, Monthly, Twice a Month, Quarterly, Yearly.
Plus options to select specific days of the week.
 From my perspective most meetings are not Daily,
 but twice a week on Tues and Thurs, or Mon-Wed-Fri
 or some such set up.*/

export const RECURRENCE_FREQ = {
  daily: 'Daily',
  weekly: 'Weekly',
  weekdays: 'Specific days',
  monthly: 'Monthly',
  biMonthly: 'Bi-monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  none: 'No recurrence',
};

export const RECURRENCE_END = {
  date: 'End date',
  repeats: 'times',
};

export const WEEKDAYS = {
  monday: { id: 1, str: 'Mo' },
  tuesday: { id: 2, str: 'Tu' },
  wednesday: { id: 3, str: 'We' },
  thursday: { id: 4, str: 'Th' },
  friday: { id: 5, str: 'Fr' },
  saturday: { id: 6, str: 'Sa' },
  sunday: { id: 0, str: 'Su' },
};

export const RECURRING_CANCEL_OPTIONS = {
  onlyThis: 'onlyThis',
  allUpcoming: 'allUpcoming',
};

export const EVENT_INVITE_STATUS = {
  accepted: 'Accepted',
  declined: 'Declined',
  tentative: 'Tentative',
  recurring: 'Recurring',
};

export const EVENT_FILTER_TYPE = {
  all: 'All events',
  contacts: 'Contacts',
  group: 'Group',
  noInvites: 'No invitations',
};

export const isEditableEvent = (e, memberId) => {
  if (!!e.group_info) {
    if (e?.group_info?.group_leader_id === memberId) {
      return true;
    } else {
      return false;
    }
  } else {
    if (e?.host_member_info?.host_member_id === memberId) {
      return true;
    } else {
      return false;
    }
  }
};

const getDayString = (wdid) =>
  Object.entries(WEEKDAYS)
    .map((kv) => kv[1])
    .find((v) => v.id === wdid).str;

const recurrenceEndString = (endCondition, endDate, repeatTimes) => {
  let endString;

  if (endCondition === RECURRENCE_END.date) {
    endString = `until ${format(endDate, 'MMM Lo yyyy')}.`;
  } else if (endCondition === RECURRENCE_END.repeats) {
    endString = `after ${repeatTimes} events.`;
  }

  return `, ends ${endString}`;
};

export const recurrenceText = (
  frequency,
  endCondition,
  endDate,
  repeatTimes,
  repeatWkDays
) => {
  if (frequency === RECURRENCE_FREQ.none) {
    return `Not a recurring event`;
  } else {
    if (frequency === RECURRENCE_FREQ.weekdays) {
      console.log('repeatWkDays', repeatWkDays);

      const weekDaysParsed = isArray(repeatWkDays)
        ? repeatWkDays
        : JSON.parse(repeatWkDays);

      return `Repeats weekly on ${weekDaysParsed
        .map((wdid) => getDayString(wdid))
        .join(', ')} ${recurrenceEndString(
        endCondition,
        endDate,
        repeatTimes
      )}`;
    } else {
      return `Repeats ${frequency} ${recurrenceEndString(
        endCondition,
        endDate,
        repeatTimes
      )}`;
    }
  }
};

// Takes a date with some timezone (provided by picker)
// Converts is to a date with another target timezone (which is usually selected by user)
export const changeTz = (date, targetTz) => {
  const newTime = utcToZonedTime(date, targetTz);
  console.log('picked time', date);
  console.log('target zone', targetTz);
  console.log('new time', newTime);
  console.log('new time to UTC', zonedTimeToUtc(newTime, targetTz));
};

export const makeUtcDate = (date) => {
  // const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // Strip off timezone
  console.log('Input date', date);
  const ISOstr = formatISO9075(date);
  console.log('TZ stripped string', ISOstr);
  // Parse again
  console.log('UTC something', toDate(ISOstr, { timeZone: 'Etc/UTC' }));
};

const frequencyToIncrement = (option) => {
  if (option === RECURRENCE_FREQ.daily) {
    return { days: 1 };
  } else if (option === RECURRENCE_FREQ.weekly) {
    return { weeks: 1 };
  } else if (option === RECURRENCE_FREQ.monthly) {
    return { months: 1 };
  } else if (option === RECURRENCE_FREQ.biMonthly) {
    return { weeks: 2 };
  } else if (option === RECURRENCE_FREQ.quarterly) {
    return { months: 3 };
  } else if (option === RECURRENCE_FREQ.yearly) {
    return { years: 1 };
  }
};

const isSelectedWeekday = (date, repeatWeekDays) => {
  const weekday = getDay(date);
  return !!repeatWeekDays.find((wdid) => wdid === weekday);
};

// Gets a string in UTC given a date and a timezone
export const formatInTimeZone = (date, tz) => {
  console.debug(`Date: ${date}`);
  console.debug(`TZ: ${tz}`);
  try {
    return formatTZ(utcToZonedTime(date, tz), 'yyyy-MM-dd HH:mm:ss', {
      timeZone: tz,
    });
  } catch (e) {
    console.debug(`UTC: ${utcToZonedTime(date, tz)}`);
    console.exception();
    console.error(e);
    return date;
  }
};

export const parseFromStr = (dateStr, tz) => toDate(dateStr, { timeZone: tz });

export const defaultEventName = (metadata) => {
  const { type } = metadata;
  const typePortion = eventTypeText(type);
  return `${typePortion}${eventTypePortion(metadata)}`;
};

export const prepareForm = (state, attachments) => {
  const {
    start,
    colorId,
    end,
    recurrence,
    endCondition,
    repeatWeekDays,
    endDate,
    repeatTimes,
  } = state;

  let metadata = { ...state, attachments, recurringCopies: [] };
  let recurringCopies = [];
  if (recurrence !== RECURRENCE_FREQ.none) {
    // Differrnece in seconds between
    const diffSecs = differenceInSeconds(end, start);
    // Find put the start and end dates for all recurring events
    if (endCondition === RECURRENCE_END.date) {
      if (recurrence !== RECURRENCE_FREQ.weekdays) {
        let maxStart = start;
        let maxEnd = end;
        while (isBefore(maxStart, endDate)) {
          const scopedStart = add(maxStart, frequencyToIncrement(recurrence));
          const scopedEnd = add(maxEnd, frequencyToIncrement(recurrence));
          recurringCopies.push({
            start: formatInTimeZone(scopedStart, 'UTC'),
            end: formatInTimeZone(scopedEnd, 'UTC'),
          });
          maxStart = scopedStart;
          maxEnd = scopedEnd;
        }
      } else {
        // iterate over days
        let maxStart = add(start, { days: 1 });
        while (isBefore(maxStart, endDate)) {
          const scopedStart = maxStart;
          console.log('Scope start', scopedStart);
          const scopedEnd = add(scopedStart, { seconds: diffSecs });
          if (isSelectedWeekday(scopedStart, repeatWeekDays)) {
            // If the day is our type of weekday
            recurringCopies.push({
              start: formatInTimeZone(scopedStart, 'UTC'),
              end: formatInTimeZone(scopedEnd, 'UTC'),
            });
          }
          maxStart = add(scopedStart, { days: 1 });
        }
      }
    } else if (endCondition === RECURRENCE_END.repeats) {
      let eventCount = 1;
      let maxStart = start;
      let maxEnd = end;
      if (recurrence !== RECURRENCE_FREQ.weekdays) {
        while (eventCount < repeatTimes) {
          const scopedStart = add(maxStart, frequencyToIncrement(recurrence));
          const scopedEnd = add(maxEnd, frequencyToIncrement(recurrence));
          recurringCopies.push({
            start: formatInTimeZone(scopedStart, 'UTC'),
            end: formatInTimeZone(scopedEnd, 'UTC'),
          });
          maxStart = scopedStart;
          maxEnd = scopedEnd;
          eventCount += 1;
        }
      } else {
        let maxStart = add(start, { days: 1 });
        while (eventCount < repeatTimes) {
          const scopedStart = maxStart;
          const scopedEnd = add(scopedStart, { seconds: diffSecs });
          if (isSelectedWeekday(scopedStart, repeatWeekDays)) {
            // If the day is our type of weekday
            recurringCopies.push({
              start: formatInTimeZone(scopedStart, 'UTC'),
              end: formatInTimeZone(scopedEnd, 'UTC'),
            });
            // here we update the counter only on hits
            eventCount += 1;
          }
          maxStart = add(scopedStart, { days: 1 });
        }
      }
    }
  }
  metadata = {
    ...metadata,
    /* 2021-01-29 -- Now we don't synthetize the event name to store. 
    Instead we synthetize it when we display it (and it is defferent for each invitee) */
    colorId: colorId === 'no-color' ? null : colorId,
    start: formatInTimeZone(metadata.start, 'UTC'),
    end: formatInTimeZone(metadata.end, 'UTC'),
    endDate: !!metadata.endDate
      ? formatInTimeZone(metadata.endDate, 'UTC')
      : null,
    recurringCopies,
    locationMode:
      metadata.locationMode === LOCATION_TYPES.find
        ? LOCATION_TYPES.lookup
        : metadata.locationMode,
    /*
      If group mode => group id,
      if contacts mode => null
    */
    invitedGroup:
      metadata.inviteMode === INVITE_MODE.group
        ? metadata.invitedGroup.group_id
        : null,
    /*
      If contacts mode => contacts id
      If group mode => group ids for memebers with isShouldInvite
    */
    invitedMembers:
      metadata.inviteMode === INVITE_MODE.contacts
        ? metadata.invitedMembers.map((imo) => imo.contact_member_id)
        : metadata?.invitedGroup?.members.length > 0
        ? metadata.invitedGroup.members
            .filter((m) => m.isShouldInvite)
            .map((m) => m.contact_member_id)
        : null,
    attachments:
      metadata.attachments.length > 0
        ? metadata.attachments.map((ao) => ao.member_file_id)
        : [],
  };

  console.debug('event data send object', metadata);

  let formData = new FormData();
  formData.set('event_data', JSON.stringify(metadata));
  return formData;
};

export const prepareChangesForms = (state, attachments) => {
  const metadata = {
    ...state,
    colorId: state.colorId === 'no-color' ? null : state.colorId,
    locationMode:
      state.locationMode === LOCATION_TYPES.find
        ? LOCATION_TYPES.lookup
        : state.locationMode,
    attachments,
    invitations:
      state.inviteMode === INVITE_MODE.contacts
        ? state.invitations
        : eventChangeInvitationHelper(
            state.invitations,
            state.invitedGroup.members
          ),
    start: formatInTimeZone(state.start, 'UTC'),
    end: formatInTimeZone(state.end, 'UTC'),
  };
  console.log('changes form data content', metadata);
  let formData = new FormData();
  formData.set('event_data', JSON.stringify(metadata));
  return formData;
};

export const eventPropGetter = (
  event,
  start,
  end,
  isSelected,
  colors,
  view
) => {
  const { event_color_id } = event;
  const eventColor = !!event_color_id
    ? colors.find((co) => co.id === event_color_id)?.color
    : '#F8FAFF';

  const eventProps = {
    className: '',
  };
  if (view !== CALENDAR_VIEWS.agenda) {
    eventProps.style = {
      backgroundColor: eventColor,
      color: invert(eventColor, true),
    };
  }
  return eventProps;
};

// https://app.clubhouse.io/amera-sharing/story/90/fetch-from-api-events-based-on-view-constraints
// Returns UTC ISO string to make a call
export const getParams = (view, range) => {
  let start, end;
  console.debug(`Calendar View: ${view}`);
  console.debug(`Calendar Range: ${JSON.stringify(range)}`);

  if (view === CALENDAR_VIEWS.month) {
    start = formatInTimeZone(range?.start, 'UTC');
    end = formatInTimeZone(range?.end, 'UTC');
    // console.log('month', start, end);
  } else if (view === CALENDAR_VIEWS.week) {
    start = formatInTimeZone(min(range), 'UTC');
    end = formatInTimeZone(max(range), 'UTC');
    // console.log('week', start, end);
  } else if (view === CALENDAR_VIEWS.day) {
    // console.log('day', range[0]);
    start = formatInTimeZone(setHours(range[0], 0), 'UTC');
    end = formatInTimeZone(setHours(range[0], 24), 'UTC');
  } else if (view === CALENDAR_VIEWS.agenda) {
    start = formatInTimeZone(range?.start, 'UTC');
    end = formatInTimeZone(range?.end, 'UTC');
    // console.log('agenda', start, end);
  }

  // console.log('UTC strings', start, end);
  return { start, end };
};

export const getMonthLimits = (current = null) => {
  if (!current) current = new Date();
  return {
    start: startOfMonth(current),
    end: endOfMonth(current),
  };
};

// As per request for a fixed list
export const durationOptions = [
  { value: 15, str: '0:15' },
  { value: 30, str: '0:30' },
  { value: 60, str: '1:00' },
  { value: 90, str: '1:30' },
  { value: 120, str: '2:00' },
  { value: 150, str: '2:30' },
  { value: 180, str: '3:00' },
  { value: 210, str: '3:30' },
  { value: 240, str: '4:00' },
  { value: 480, str: '8:00' },
  { value: 'custom', str: 'Not Applicable' },
];

// This was used in 2020 to render a list of options with a given minutes step and max duration
export const getDurationOptions = (stepMinutes, MAX_DURATION_HOURS) => {
  let minutesRange = range(stepMinutes, MAX_DURATION_HOURS * 60, stepMinutes);
  if (!includes(minutesRange, MAX_DURATION_HOURS * 60)) {
    minutesRange.push(MAX_DURATION_HOURS * 60);
  }

  let options = minutesRange.map((m) => ({
    value: m,
    str: minutesToHumanReadableDuration(m),
  }));
  options.push({ value: 'custom', str: 'Custom' });
  options.push({ value: 'tooHigh', str: '> 8:00' });

  return options;
};

const minutesToHumanReadableDuration = (minutes) => {
  if (minutes < 60) {
    return `0:${minutes}`;
  } else if (minutes === 60) {
    return '1:00';
  } else if (minutes > 60 && minutes < 120) {
    return `1:${minutes % 60}`;
  } else if (includes([120, 180, 240, 300, 360, 420, 480], minutes)) {
    return `${minutes / 60}:00`;
  } else {
    return `${Math.floor(minutes / 60)}:${minutes % 60}`;
  }
};

// We take the current date 00:00, iterate + X minutes until = 24:00{
export const getTimeLimits = (date, stepMinutes) => {
  const rangeStartDate = set(date, {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  let scopedDate = rangeStartDate;

  let results = [];

  while (isBefore(scopedDate, add(rangeStartDate, { days: 1 }))) {
    results.push({ value: scopedDate, str: format(scopedDate, 'p') });

    scopedDate = add(scopedDate, { minutes: stepMinutes });
  }

  return results;
};

export const roundToNextHour = (date) => {
  const hours = getHours(date) + 1;
  return set(date, { hours, minutes: 0, seconds: 0, milliseconds: 0 });
};

// Pretty event dates and duration line for event info modal
export const eventTimeText = (start, end, isFullDay) => {
  const date_format = 'eeee, MM/dd/yyyy';

  if (isSameDay(start, end)) {
    if (isFullDay) {
      return `${format(start, date_format)}`;
    } else {
      return `${format(start, date_format)}  -  ${format(
        start,
        'p'
      )} to ${format(end, 'p')}`;
    }
  } else {
    if (isFullDay) {
      return `${format(start, date_format)} to ${format(end, date_format)}`;
    } else {
      return `${format(start, date_format)} ${format(start, 'p')} to ${format(
        end,
        date_format
      )} ${format(end, 'p')}`;
    }
  }
};

// Group invite helpers
export const parseGroupToState = (
  groupObject,
  isCreateModal = true,
  invitations = null
) => {
  if (!!groupObject) {
    const { group_id, group_name } = groupObject;
    return {
      group_id,
      group_name,
      members:
        !!groupObject.members && groupObject.members.length > 0
          ? groupObject.members.map((mo) => ({
              contact_member_id: mo.id,
              isShouldInvite: invitationHelper(
                mo.id,
                invitations,
                isCreateModal
              ),
              // inviteStatus: EVENT_INVITE_STATUS.unsent,
              contact_name: displayableFullName(mo),
            }))
          : [],
    };
  } else {
    return {};
  }
};

const invitationHelper = (groupMemberId, invitations, isCreateModal) => {
  if (isCreateModal) {
    return true;
  } else {
    if (!!invitations) {
      const invitedMemberIds = invitations.map((io) => io.invite_member_id);
      if (includes(invitedMemberIds, groupMemberId)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
};

//  This will format the state to make an invitations object that webapi can process
const eventChangeInvitationHelper = (invitations, groupMembers) => {
  // Keep only the invitations for checked group members
  const shouldInviteMemberIds = groupMembers
    .filter((gmo) => gmo.isShouldInvite)
    .map((gmo) => gmo.contact_member_id);
  const previouslyInvitedMemberIds = !!invitations
    ? invitations.map((io) => io.invite_member_id)
    : [];

  return shouldInviteMemberIds.map((id) => {
    if (includes(previouslyInvitedMemberIds, id)) {
      // Was invited, stays invoited
      return invitations.find((io) => io.invite_member_id === id);
    } else {
      // Was not invited, will be
      return { invite_member_id: id, invite_id: shortid.generate() };
    }
  });
};

// Filter events based on focused contact OR group
export const filterEvents = (events, eventsFilter) => {
  const { filterType, contacts, group } = eventsFilter;

  if (filterType === EVENT_FILTER_TYPE.all) {
    return events;
  } else if (
    filterType === EVENT_FILTER_TYPE.contacts &&
    !!contacts &&
    contacts.length > 0
  ) {
    return events.filter(
      (eo) =>
        eo.group_info === null &&
        !!eo.invitations &&
        intersection(
          contacts.map((co) => co.contact_member_id),
          // This will include host member to filter
          [
            ...eo.invitations.map((io) => io.invite_member_id),
            eo.host_member_info.host_member_id,
          ]
        ).length > 0
    );
  } else if (filterType === EVENT_FILTER_TYPE.group && !!group) {
    return events.filter(
      (eo) => !!eo.group_info && eo.group_info.group_id === group.group_id
    );
  } else if (filterType === EVENT_FILTER_TYPE.noInvites) {
    return events.filter((eo) => eo.invitations === null);
  } else {
    // Fallback
    return events;
  }
};

export const filterDescription = (eventsFilter) => {
  const { filterType, contacts, group } = eventsFilter;
  if (filterType === EVENT_FILTER_TYPE.all) {
    return 'All events';
  } else if (
    filterType === EVENT_FILTER_TYPE.contacts &&
    !!contacts &&
    contacts.length > 0
  ) {
    return `Events with ${contacts
      .map((co) => displayableFullName(co))
      .join(', ')}`;
  } else if (filterType === EVENT_FILTER_TYPE.group && !!group) {
    return `${group.group_name} events`;
  } else if (filterType === EVENT_FILTER_TYPE.noInvites) {
    return 'Events with no invites';
  } else {
    return '';
  }
};

// calculate event duration with start/end date
export const calcEventDuration = (start, end) => {
  const diff_mis = differenceInMinutes(end, start);
  const oneDayMins = 24 * 60;

  if (diff_mis >= oneDayMins) {
    const days = Math.floor(diff_mis / oneDayMins);

    return formatDuration({ days });
  } else {
    return formatDuration({
      hours: Math.floor(diff_mis / 60),
      minutes: diff_mis % 60,
    });
  }
};

// https://developers.google.com/places/supported_types?hl=ru#table1
export const GPLACES_TYPES = {
  restaraunt: 'restaurant',
  park: 'park',
  airport: 'airport',
  bank: 'bank',
  cafe: 'cafe',
  city_hall: 'city_hall',
  embassy: 'embassy',
  bar: 'bar',
};

export const EAT_GPLACES = [
  GPLACES_TYPES.restaraunt,
  GPLACES_TYPES.bar,
  GPLACES_TYPES.cafe,
];

export const googlePlaceToReadable = (place) => {
  return capitalize(place.replace('_', ' '));
};

const eventTypePortion = (state) => {
  const { inviteMode, invitedMembers, invitedGroup } = state;
  let invitePortion = '';

  if (inviteMode === INVITE_MODE.contacts && invitedMembers.length > 0) {
    invitePortion = ` with ${invitedMembers
      .map((im) => displayableFullName(im))
      .join(', ')}`;
  } else if (inviteMode === INVITE_MODE.group && !!invitedGroup) {
    invitePortion = ` with ${invitedGroup.group_name}`;
  }
  return invitePortion;
};
export const eventTitle = (state) => {
  return `Create event${eventTypePortion(state)}`;
};

export const getInvitedListFilterLoggedInMember = (event, loggedMemberId) => {
  event.invitations = event.invitations || [];

  return [...event.invitations, event.host_member_info].filter(
    (mo) =>
      mo.invite_member_id !== loggedMemberId &&
      mo.host_member_id !== loggedMemberId
  );
};

export const generateEventInviteListText = (inviteList) => {
  const inviteListDisplay = inviteList
    .slice(0, 3)
    .map((imo) => displayableFullName(imo))
    .join(', ');
  return `${inviteListDisplay} ${
    inviteList && inviteList.length > 3
      ? ` and ${inviteList.length - 3} Other${
          inviteList.length - 3 > 1 ? 's' : ''
        }`
      : ''
  }`;
};

export const eventDisplayName = (event, loggedMemberId) => {
  if (!!event.name) {
    return event.name;
  } else if (!!event.event_name) {
    return event.event_name;
  } else {
    const typePortion = eventTypeText(event.event_type);
    let invitePortion = '';
    if (!!event.group_info) {
      invitePortion = ` with ${event.group_info.group_name}`;
    } else {
      if (!!event.invitations && event.invitations.length > 0) {
        const involvedMembersButLogged = getInvitedListFilterLoggedInMember(
          event,
          loggedMemberId
        );

        invitePortion = ` with ${generateEventInviteListText(
          involvedMembersButLogged
        )}`;

        return `${typePortion}${invitePortion}`;
      }
    }
    return `${typePortion}${invitePortion}`;
  }
};
